var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrdtjnstBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "fardtjanst",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 177.08 129.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "border",
    d: "M36.37.25H171.44s-1,29.44,1.84,43.85c2.52,12.77,4.38,48.31,3.18,50.12s-6.49,2.41-6.71,3.39-1.66,7.83-6.42,9.68-10.05-2.16-13.39-2.41-21.61,6.25-22.62,7-2.07,9.41-6.47,12.31c-3.13,2.06-18.92,5.13-25.84,4.9s-34.13,1.39-40.95-2-28.07-8.32-33.6-6.49S10,123.16,9,120.11s1.49-49.27-.18-51.06S-1.74,64.66.65,57.79,7.33,41.44,9.29,39.67s2.64-12.52,5.79-16.58S26.72,25.55,29.33,27s6.86,1.29,6.86,1.29Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.493273049592972px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrdtjnstBorder);
export default __webpack_public_path__ + "static/media/färdtjänst-border.857241ef.svg";
export { ForwardRef as ReactComponent };